/* Loëla — tablette / ordinateur (copie AH26 — Audit conversion). Agence Conversion & design.
   v5 — 2026-10-14 : maquettes 30:7, 31:7, 32:7, 33:7 ; décisions de Valentin du 14/10 11h18.
   Fil d'Ariane, description ouverte (>= 700 px), total look en bande sous la fiche, tuile « Le look de la semaine ».
   v5.1 — 2026-10-14 (VETO du contrôleur) : description limitée à 200 px + « Lire la suite » en tablette / ordinateur.
   Grille : agencies/conversion/controles/2026-10-14_grille-desktop-tablette.md
   Ne modifie aucune donnée (prix, stock, variantes) : uniquement des déplacements d'éléments et des classes d'affichage. */
(function () {
  'use strict';
  var mqTablet = window.matchMedia('(min-width: 700px) and (max-width: 999px)');
  var mqWide = window.matchMedia('(min-width: 700px)');

  /* Fil d'Ariane : modèle émis par snippets/loela-v5-data.liquid, masqué en CSS sous 700 px */
  function crumbs() {
    var tpl = document.getElementById('loela-crumbs-tpl');
    if (!tpl || document.querySelector('.loela-crumbs')) return;
    var anchor = document.querySelector('.loela-coll-head') || document.querySelector('.shopify-section--main-product .product');
    if (!anchor) return;
    var nav = tpl.content.firstElementChild.cloneNode(true);
    var h1 = document.querySelector('.loela-coll-head h1');
    var cur = nav.querySelector('[aria-current]');
    if (h1 && cur) cur.textContent = h1.textContent.trim();
    anchor.parentNode.insertBefore(nav, anchor);
  }

  /* Fiche : description ouverte au chargement en tablette / ordinateur, fermée sur mobile (D3) */
  var descDone = false;
  function descOpen() {
    if (descDone || !mqWide.matches) return;
    var d = document.querySelector('.product-info [data-block-id=description] details');
    if (!d) return;
    descDone = true;
    if (!d.open) { d.open = true; d.setAttribute('aria-expanded', 'true'); }
  }

  /* v5.1 : description ouverte mais limitée à 200 px avec « Lire la suite » (>= 700 px), pour que la colonne d'achat
     reste plus courte que la galerie et donc collante (bouton d'achat visible pendant le défilement des photos) */
  function descClamp() {
    var item = document.querySelector('.product-info [data-block-id=description]');
    var content = item && item.querySelector('.accordion__content');
    if (!content) return;
    var btn = item.querySelector('.loela-desc-more');
    if (!mqWide.matches) {
      item.classList.remove('loela-desc-clamp', 'is-expanded');
      if (btn) btn.parentNode.removeChild(btn);
      return;
    }
    if (btn || item.classList.contains('loela-desc-clamp')) return;
    if (content.scrollHeight <= 260) return;
    item.classList.add('loela-desc-clamp');
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'loela-desc-more';
    btn.textContent = 'Lire la suite';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-expanded');
      btn.textContent = open ? 'Réduire' : 'Lire la suite';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    content.parentNode.insertBefore(btn, content.nextSibling);
  }

  /* Fiche : total look en bande pleine largeur sous les 2 colonnes (>= 700 px), remis dans la colonne sur mobile */
  var home = null;
  function band() {
    var grid = document.querySelector('.shopify-section--main-product .product');
    if (!grid) return;
    var inCol = document.querySelector('.product-info [data-block-id=complementary_products]');
    var moved = document.querySelector('.loela-band');
    if (inCol && moved && inCol !== moved) { moved.parentNode.removeChild(moved); moved = null; }
    if (mqWide.matches) {
      if (inCol && !moved) {
        home = { parent: inCol.parentNode, next: inCol.nextSibling };
        inCol.classList.add('loela-band');
        grid.parentNode.insertBefore(inCol, grid.nextSibling);
      }
    } else if (moved && home && home.parent.isConnected) {
      moved.classList.remove('loela-band');
      home.parent.insertBefore(moved, home.next && home.next.parentNode === home.parent ? home.next : null);
    }
  }

  /* Collection : « Le look de la semaine » en tuile de 2 colonnes dans la grille (D1) — après 4 cartes sur mobile
     (2e rangée) et en ordinateur, après 3 en tablette ; jamais sur les bijoux (indicateur #loela-look).
     Contenu repris de la section « shop the look » existante : photo, popover des produits, bouton d'ouverture */
  var tile = null;
  function lookTile() {
    var list = document.querySelector('.shopify-section--main-collection .product-list');
    var flag = document.getElementById('loela-look');
    if (!list || !flag || flag.textContent.trim() !== 'true') return;
    if (!tile) {
      var sec = document.querySelector('.shopify-section--shop-the-look');
      /* section masquée (collections bijoux : règle du bloc « titre_court ») : pas de tuile */
      if (!sec || window.getComputedStyle(sec).display === 'none') return;
      var item = sec.querySelector('.md\\:hidden .shop-the-look__item');
      if (!item) return;
      var pop = item.querySelector('shop-the-look-popover');
      var btn = pop ? sec.querySelector('.md\\:hidden button[aria-controls="' + pop.id + '"]') : null;
      var kicker = sec.querySelector('.section-header .h6');
      var names = [];
      Array.prototype.forEach.call((pop || item).querySelectorAll('.product-title'), function (t) {
        var s = t.textContent.replace(/\s+/g, ' ').trim();
        if (s && names.indexOf(s) === -1) names.push(s);
      });
      tile = document.createElement('div');
      tile.className = 'loela-look-tile';
      var text = document.createElement('div');
      text.className = 'loela-look-tile__text';
      var h = document.createElement('p');
      h.className = 'loela-look-tile__title';
      h.textContent = kicker ? kicker.textContent.trim() : 'Le look de la semaine';
      text.appendChild(h);
      if (btn) {
        btn.className = 'loela-look-tile__btn';
        btn.textContent = (names.length ? names.join(', ') : 'Voir les produits') + ' →';
        btn.setAttribute('aria-label', 'Voir les produits du look' + (names.length ? ' : ' + names.join(', ') : ''));
        text.appendChild(btn);
      }
      tile.appendChild(item);
      tile.appendChild(text);
      sec.classList.add('loela-look-moved');
    }
    var cards = list.querySelectorAll(':scope > product-card');
    if (!cards.length) return;
    var ref = cards[Math.min(mqTablet.matches ? 3 : 4, cards.length) - 1];
    if (ref.nextElementSibling !== tile) list.insertBefore(tile, ref.nextSibling);
  }

  function run() {
    if (document.querySelector('.product-info')) { descOpen(); descClamp(); band(); }
    if (document.querySelector('.shopify-section--main-collection')) lookTile();
    crumbs();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); });
  }

  function start() {
    run();
    var main = document.getElementById('main');
    /* les filtres, « Voir plus » et le changement de modèle remplacent des morceaux de page */
    if (main && window.MutationObserver) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    [mqTablet, mqWide].forEach(function (mq) {
      if (mq.addEventListener) mq.addEventListener('change', schedule); else if (mq.addListener) mq.addListener(schedule);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
